import { createReducer } from "reduxsauce";

import UIDs from "../../../UIDs";

import ReducerRegister from "../../ReducerRegister";
import { ActionTypes } from "../../actionTypes/screens/learn/CommentListActionTypes";
import BookCommentService from "../../../services/screens/learn/BookCommentService";
import AsyncActionReducers from "../../AsyncActionReducers";
import { ActionTypes as AddCommentActionTypes } from "../../actionTypes/screens/learn/AddCommentActionTypes";

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, vo });

            BookCommentService.loadScreenView(vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error,
    }),

    searchCommentsAsync: (vo, loadMore) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SEARCH_COMMENTS_ASYNC, vo, loadMore });

            BookCommentService.searchComments(vo,
                response => {
                    dispatch(Actions.searchCommentsSuccess(response, loadMore));
                },
                error => {
                    dispatch(Actions.searchCommentsFailure(error));
                }
            );
        };
    },

    searchCommentsSuccess: (data, loadMore) => ({
        type: ActionTypes.SEARCH_COMMENTS_SUCCESS,
        parentType: ActionTypes.SEARCH_COMMENTS_ASYNC,
        postReducer: searchCommentsSuccessReducer,
        data, loadMore
    }),

    searchCommentsFailure: error => ({
        type: ActionTypes.SEARCH_COMMENTS_FAILURE,
        parentType: ActionTypes.SEARCH_COMMENTS_ASYNC,
        error,
    }),

    removeCommentAsync: (commentId, commentType) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.REMOVE_COMMENT_ASYNC, commentId, commentType });

            BookCommentService.deleteComment({ commentId },
                response => {
                    dispatch(Actions.removeCommentSuccess(commentId, commentType));
                },
                error => {
                    dispatch(Actions.removeCommentFailure(error));
                }
            );
        };
    },

    removeCommentSuccess: (commentId, commentType) => ({
        type: ActionTypes.REMOVE_COMMENT_SUCCESS,
        parentType: ActionTypes.REMOVE_COMMENT_ASYNC,
        postReducer: removeCommentSuccessPostReducer,
        commentId, commentType
    }),

    removeCommentFailure: error => ({
        type: ActionTypes.REMOVE_COMMENT_FAILURE,
        parentType: ActionTypes.REMOVE_COMMENT_ASYNC,
        error,
    }),

    addCommentLikeAsync: (commentId) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.ADD_COMMENT_LIKE_ASYNC, commentId });

            BookCommentService.saveCommentLike({ commentId },
                response => {
                    dispatch(Actions.addCommentLikeSuccess(commentId));
                },
                error => {
                    dispatch(Actions.addCommentLikeFailure(error));
                }
            );
        };
    },

    addCommentLikeSuccess: commentId => ({
        type: ActionTypes.ADD_COMMENT_LIKE_SUCCESS,
        parentType: ActionTypes.ADD_COMMENT_LIKE_ASYNC,
        postReducer: addCommentLikeSuccessPostReducer,
        commentId
    }),

    addCommentLikeFailure: error => ({
        type: ActionTypes.ADD_COMMENT_LIKE_FAILURE,
        parentType: ActionTypes.ADD_COMMENT_LIKE_ASYNC,
        error,
    }),

    removeCommentLikeAsync: (commentId) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.REMOVE_COMMENT_LIKE_ASYNC, commentId });

            BookCommentService.deleteCommentLike({ commentId },
                response => {
                    dispatch(Actions.removeCommentLikeSuccess(commentId));
                },
                error => {
                    dispatch(Actions.removeCommentLikeFailure(error));
                }
            );
        };
    },

    removeCommentLikeSuccess: (commentId) => ({
        type: ActionTypes.REMOVE_COMMENT_LIKE_SUCCESS,
        parentType: ActionTypes.REMOVE_COMMENT_LIKE_ASYNC,
        postReducer: removeCommentLikeSuccessPostReducer,
        commentId
    }),

    removeCommentLikeFailure: error => ({
        type: ActionTypes.REMOVE_COMMENT_LIKE_FAILURE,
        parentType: ActionTypes.REMOVE_COMMENT_LIKE_ASYNC,
        error,
    }),

    changeSearchState: data => ({
        type: ActionTypes.CHANGE_SEARCH_STATE,
        data
    }),

    refreshScreenAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.REFRESH_SCREEN_ASYNC });

            BookCommentService.loadScreenView(
                response => {
                    dispatch(Actions.refreshScreenSuccess(response));
                },
                error => {
                    dispatch(Actions.refreshScreenFailure(error));
                }
            );
        };
    },

    refreshScreenSuccess: data => ({
        type: ActionTypes.REFRESH_SCREEN_SUCCESS,
        parentType: ActionTypes.REFRESH_SCREEN_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
    }),

    refreshScreenFailure: error => ({
        type: ActionTypes.REFRESH_SCREEN_FAILURE,
        parentType: ActionTypes.REFRESH_SCREEN_ASYNC,
        error,
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    searchVo: {
        courseId: null,
        type: -2,
        isDescOrder: false,
        pageIndex: 1,
        pageSize: 10,
    },
    scoreVo: null,
    totalCount: 0,
    comments: null,
    hasCommented: false,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    const { commentListVm } = data;
    return {
        ...state,
        scoreVo: commentListVm.scoreVo,
        totalCount: commentListVm.pagedComments.totalCount,
        hasCommented: commentListVm.hasCommented,
        comments: commentListVm.pagedComments.comments,
    };
};

const searchCommentsSuccessReducer = (state, { data, loadMore }) => {
    if (loadMore) {
        const { comments } = state;
        let newComments = Array.from(comments);
        if (data.totalCount > 0)
            newComments = newComments.concat(data.comments)
        return {
            ...state,
            comments: newComments,
        };
    }
    else
        return { ...state, comments: data.comments };
};

const addCommentSuccessPostReducer = (state, { data }) => {
    const { searchVo, comments, scoreVo, totalCount } = state;
    let newComments = [];
    if (searchVo.type === -2 || searchVo.type === -1 || searchVo.type === data.type) {
        if (comments && comments.length > 0) {
            newComments = Array.from(comments);
            newComments.splice(0, 0, data);
        } else {
            newComments.push(data);
        }
    }

    let newScoreVo = scoreVo;
    switch (data.type) {
        case 0:
            newScoreVo.good++;
            break;
        case 1:
            newScoreVo.common++;
            break;
        case 2:
            newScoreVo.bad++;
            break;
    }
    newScoreVo.score = newScoreVo.good === 0 ? 0 : (newScoreVo.good / (newScoreVo
        .good + newScoreVo.common + newScoreVo.bad)).toFixed(1) * 100;

    let newtotalCount = totalCount + 1;
    return {
        ...state,
        comments: newComments,
        totalCount: newtotalCount,
        hasCommented: true,
        scoreVo: newScoreVo,
    };
};

const removeCommentSuccessPostReducer = (state, { commentId, commentType }) => {
    const { comments, scoreVo, totalCount } = state;
    let newComments = Array.from(comments);
    if (newComments && newComments.length > 0) {
        let idx = newComments.findIndex(c => c.commentId === commentId);
        if (idx >= 0) {
            newComments.splice(idx, 1);
        }
    }

    let newScoreVo = scoreVo;
    switch (commentType) {
        case 0:
            newScoreVo.good--;
            break;
        case 1:
            newScoreVo.common--;
            break;
        case 2:
            newScoreVo.bad--;
            break;
    }
    newScoreVo.score = newScoreVo.good === 0 ? 0 : (newScoreVo.good / (newScoreVo
        .good + newScoreVo.common + newScoreVo.bad)).toFixed(1) * 100;
    let newtotalCount = totalCount - 1;

    return {
        ...state,
        scoreVo: newScoreVo,
        comments: newComments,
        totalCount: newtotalCount,
        hasCommented: false,
    };
};

const addCommentLikeSuccessPostReducer = (state, { commentId }) => {
    const { comments } = state;
    let newComments = Array.from(comments);

    let idx = newComments.findIndex(c => c.commentId === commentId);
    if (idx >= 0) {

        newComments[idx].isLike = true;
        newComments[idx].totalLikesCount++;
    }

    return {
        ...state,
        comments: newComments
    };
};

const removeCommentLikeSuccessPostReducer = (state, { commentId }) => {
    const { comments } = state;
    let newComments = Array.from(comments);

    let idx = newComments.findIndex(c => c.commentId === commentId);
    if (idx >= 0) {

        newComments[idx].isLike = false;
        newComments[idx].totalLikesCount--;
    }

    return {
        ...state,
        comments: newComments
    };
};

const changeSearchStateReducer = (state, { data }) => {
    return {
        ...state,
        searchVo: { ...state.searchVo, ...data }
    };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SEARCH_COMMENTS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SEARCH_COMMENTS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SEARCH_COMMENTS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REMOVE_COMMENT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REMOVE_COMMENT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REMOVE_COMMENT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.ADD_COMMENT_LIKE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.ADD_COMMENT_LIKE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.ADD_COMMENT_LIKE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REMOVE_COMMENT_LIKE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REMOVE_COMMENT_LIKE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REMOVE_COMMENT_LIKE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REFRESH_SCREEN_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REFRESH_SCREEN_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REFRESH_SCREEN_FAILURE]: AsyncActionReducers.failureReducer,

    [ActionTypes.CHANGE_SEARCH_STATE]: changeSearchStateReducer,
    [AddCommentActionTypes.ADD_COMMENT_SUCCESS]: addCommentSuccessPostReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.screens.learn.commentlist, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
